const i = ":host{display:inline-block}.sl-switch{position:relative;display:inline-flex;flex-shrink:0;cursor:pointer;align-items:center;border-radius:9999px;border:2px solid transparent;transition:background-color var(--sl-transition-fast);background:none;padding:0}.sl-switch:focus-visible{outline:none;box-shadow:0 0 0 2px hsl(var(--sl-hsl-background)),0 0 0 4px hsl(var(--sl-hsl-ring))}.sl-switch--disabled{cursor:not-allowed;opacity:0.5}.sl-switch--sm{height:1rem;width:1.75rem}.sl-switch--md{height:1.25rem;width:2.25rem}.sl-switch--lg{height:1.5rem;width:2.75rem}.sl-switch--on{background-color:hsl(var(--sl-hsl-primary))}.sl-switch--off{background-color:hsl(var(--sl-hsl-input))}.sl-switch-thumb{pointer-events:none;display:block;border-radius:9999px;background-color:hsl(var(--sl-hsl-background));box-shadow:var(--sl-shadow-sm);transition:transform var(--sl-transition-fast)}.sl-switch-thumb--sm{height:0.75rem;width:0.75rem}.sl-switch-thumb--md{height:1rem;width:1rem}.sl-switch-thumb--lg{height:1.25rem;width:1.25rem}.sl-switch-thumb--off{transform:translateX(0)}.sl-switch-thumb--sm-on{transform:translateX(0.75rem)}.sl-switch-thumb--md-on{transform:translateX(1rem)}.sl-switch-thumb--lg-on{transform:translateX(1.25rem)}";
class h extends HTMLElement {
  constructor() {
    super(), this._button = null, this._handleClickBound = this._handleClick.bind(this), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  static get observedAttributes() {
    return ["checked", "disabled", "size"];
  }
  connectedCallback() {
    this._button && this._button.addEventListener("click", this._handleClickBound);
  }
  disconnectedCallback() {
    this._button && this._button.removeEventListener("click", this._handleClickBound);
  }
  attributeChangedCallback(t, s, e) {
    s !== e && this._updateContent();
  }
  get checked() {
    return this.hasAttribute("checked");
  }
  set checked(t) {
    t ? this.setAttribute("checked", "") : this.removeAttribute("checked");
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(t) {
    t ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  get size() {
    return this.getAttribute("size") || "md";
  }
  set size(t) {
    this.setAttribute("size", t);
  }
  _handleClick() {
    this.disabled || (this.checked = !this.checked, this.dispatchEvent(
      new CustomEvent("change", {
        bubbles: !0,
        composed: !0,
        detail: { checked: this.checked }
      })
    ));
  }
  _updateContent() {
    if (!this._button) return;
    const t = [
      "sl-switch",
      `sl-switch--${this.size}`,
      this.checked ? "sl-switch--on" : "sl-switch--off"
    ];
    this.disabled && t.push("sl-switch--disabled");
    const s = [
      "sl-switch-thumb",
      `sl-switch-thumb--${this.size}`,
      this.checked ? `sl-switch-thumb--${this.size}-on` : "sl-switch-thumb--off"
    ];
    this._button.className = t.join(" "), this._button.setAttribute("aria-checked", String(this.checked)), this.disabled ? this._button.setAttribute("disabled", "") : this._button.removeAttribute("disabled");
    const e = this._button.querySelector("span");
    e && (e.className = s.join(" "));
  }
  _render() {
    const t = [
      "sl-switch",
      `sl-switch--${this.size}`,
      this.checked ? "sl-switch--on" : "sl-switch--off"
    ];
    this.disabled && t.push("sl-switch--disabled");
    const s = [
      "sl-switch-thumb",
      `sl-switch-thumb--${this.size}`,
      this.checked ? `sl-switch-thumb--${this.size}-on` : "sl-switch-thumb--off"
    ];
    this._shadow.innerHTML = `
      <style>${i}</style>
      <button
        type="button"
        role="switch"
        aria-checked="${this.checked}"
        class="${t.join(" ")}"
        ${this.disabled ? "disabled" : ""}
      >
        <span class="${s.join(" ")}"></span>
      </button>
    `, this._button = this._shadow.querySelector("button");
  }
}
typeof customElements < "u" && !customElements.get("sl-switch") && customElements.define("sl-switch", h);
export {
  h as SlSwitchElement
};
//# sourceMappingURL=sl-switch.js.map
